import { render } from "./vcurriculumorder.vue?vue&type=template&id=c6bd46e4&scoped=true"
import script from "./vcurriculumorder.vue?vue&type=script&lang=js"
export * from "./vcurriculumorder.vue?vue&type=script&lang=js"

import "./vcurriculumorder.vue?vue&type=style&index=0&id=c6bd46e4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6bd46e4"]])

export default __exports__